<script>
import LoadingSpinner from "./LoadingSpinner.vue";

export default {
    props: {
        /**
         * key: string,
         * label: string,
         * width: number -> will be converted to percentage
         */
        headers: {
            type: Object,
            required: true
        }, 

        items: {
            type: Object,
            required: true,
        },

        iterator: {
            type: String,
            required: true
        },

        loading: {
            type: Boolean,
            default: false
        }
    },

    components: {
        LoadingSpinner,
    },

    data() {
        return {
            specialTypes: [
                'edit',
                'delete'
            ],
        }
    },

    computed: {
        totalWidthPoints() {
            let sum = 0;
            for (let i = 0; i < this.headers.length; i++) {
                sum += this.headers[i].width;
            }
            return sum;
        }
    },

    methods: {
        btnClick(item, eventName) {
            if (item) {
                this.$emit('btnClick', {
                    event: eventName,
                    item: item,
                });
            } else {
                console.error('Invalid item: ', item);
                this.$emit('btnClick', {
                    event: eventName,
                    item: null,
                });
            }
        },
    }
}
</script>

<template>
    <table>
        <tr>
            <th
                v-for="header in headers" :key="header.key"
                id="sust-header-row"
                :style="{
                    width: `${header.width / totalWidthPoints}%`,
                    textAlign: header.key == 'edit' || header.key == 'delete' ? 'center' : 'left'
                }"
            >
                {{ header.label }}
            </th>
        </tr>
        <tr v-for="item in items" :key="item[iterator]">
            <td
                v-for="header in headers" :key="header.key"
                :style="{
                    width: `${header.width / totalWidthPoints}%`,
                    textAlign: header.key == 'edit' || header.key == 'delete' ? 'center' : 'left'
                }"
            >
                <span v-if="header.key === 'created_on' || header.key === 'updated_on' || header.key === 'deleted_on' || header.key === 'completed_on'">
                    {{ item[header.key] | dateFormat }}
                </span>

                <button 
                    v-else-if="header.key === 'edit'" 
                    class="edit-btn"
                    @click="btnClick(item, 'edit')"
                >
                    <i class="fa-regular fa-pen-to-square"></i>
                </button>

                <button 
                    v-else-if="header.key === 'delete'" 
                    class="delete-btn"
                    @click="btnClick(item, 'delete')"
                >
                    <i class="fa-regular fa-trash-can"></i>
                </button>

                <span v-else>
                    {{ item[header.key] || 'N/A' }}
                </span>
            </td>
        </tr>

        <tr v-if="loading">
            <td :colspan="headers.length" id="no-data-text">
                <loading-spinner style="justify-self: center;" />
            </td>
        </tr>

        <tr v-else-if="items.length === 0 || !items">
            <td :colspan="headers.length" id="no-data-text">
                {{ $t('noData.text') }}
            </td>
        </tr>
    </table>
</template>

<style lang='scss' scoped>
    table {
        width: 100%;
        border-radius: 1em;
        border: 0;
        outline: 0;
        box-shadow: 0 .25em .5em .1em gray;
        overflow: hidden;

        > tr {
            width: 100%;
            border-bottom: thin solid lightgray;

            &:last-of-type {
                border-bottom: 0;
            }

            > th {
                padding: .5em;
                background-color: var(--sustainfinity-navy);
                color: whitesmoke;
                border-right: thin solid whitesmoke;

                &:last-of-type {
                    border-right: 0;
                }
            }

            > td {
                padding: .5em;
                background-color: whitesmoke;
                color: var(--sustainfinity-navy);

                > button {
                    border: 0;
                    outline: 0;
                    width: fit-content;
                    padding: .25em;
                    background: transparent;

                    &:focus {
                        outline: thin solid gray !important;
                    }

                    > i {
                        transition: color 150ms;
                    } 

                    > .fa-pen-to-square {
                        color: var(--sustainfinity-blue);
                    }

                    > .fa-trash-can {
                        color: var(--invalid-input);
                    }

                    &:hover {
                        > .fa-pen-to-square {
                            color: var(--sustainfinity-blue--hover);
                        }

                        > .fa-trash-can {
                            color: var(--invalid-input--hover);
                        }   
                    } 
                }
            }
        }
    }

    #sust-header-row {
        border-bottom: 0 !important;
    }

    #no-data-text {
        text-align: center;
        font-weight: bold;
        font-size: 1.25em;
    }
</style>